document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-recommendations product-card').forEach(card => {
    const badge = card.querySelector('.product-badges');
    const price = card.querySelector('[ref="priceContainer"]');
    if (badge && price) {
      const clone = badge.cloneNode(true);
      clone.style.position = 'static';
      clone.style.zIndex = 'auto';
      price.after(clone);
      badge.style.display = 'none';
    }
  });
});
